import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { DELIVERY_FEATURE, DeliveryState, StateWithDelivery } from '../delivery-state';

export const getDeliveryState: MemoizedSelector<StateWithDelivery, DeliveryState> =
  createFeatureSelector<DeliveryState>(DELIVERY_FEATURE);
